import { TealiumBaseEvent } from './TealiumBaseEvent';

export class TealiumAddRemoveEvent extends TealiumBaseEvent {
  static readonly ADD_EVENT = 'add';
  static readonly REMOVE_EVENT = 'remove';

  amount: number;
  newAmount: number;
  diffAmount: number;
  productSku: string;
  product_attributes_brand: string;

  constructor(productSku: string, amount: number, newAmount: number) {
    const eventType = newAmount > amount ? TealiumAddRemoveEvent.ADD_EVENT : TealiumAddRemoveEvent.REMOVE_EVENT;
    super(eventType);

    this.productSku = productSku;
    this.amount = amount;
    this.newAmount = newAmount;
    this.product_attributes_brand = this.eventValues.product_attributes_brand;
    this.diffAmount = Math.abs(this.newAmount - this.amount);

    this.uTagInfoMap = this.buildUTagProductInfoMap();
  }

  link() {
    if (this.diffAmount !== 0) {
      this.executeLink(this.productSku, { product_attributes_quantity: [this.diffAmount.toString()] });
    }
  }
}
